import { Navigate } from 'react-router-dom';
import { PageSpinner } from '@ohpen/enso-ui';
import { useGuard } from '@ohpen/react-authz';

export const DefaultRedirect = () => {
  const { allowed: canViewProducts, isLoading: productsLoading } = useGuard({ permissions: ['products:view'] });
  const { allowed: canViewFirms, isLoading: firmsLoading } = useGuard({ permissions: ['firms:view'], flags: ['enableFirms'] });

  if (productsLoading || firmsLoading) return <PageSpinner />;

  if (!canViewProducts && canViewFirms) return <Navigate to="firms" replace />;
  return <Navigate to="products" replace />;
};
